import React, { useState, useEffect } from 'react'
import { urlFor, client } from '../../client'
import { motion } from 'framer-motion'
import './about.scss'
import { AppWrapper, MotionWrapper } from '../../HOC'

const About = () => {
  const [abouts, setAbouts] = useState([]);
  const [certificates, setCertificates] = useState([]);
  useEffect(() => {
    const query = '*[_type=="abouts"]';
    const cquery = '*[_type=="certificates"]';
    client.fetch(query)
      .then((data) => setAbouts(data));
    client.fetch(cquery)
      .then((data) => setCertificates(data));
  }, [])
  return (
    <>
      <h2 className="head-text">
          Areas of&nbsp;
          <span>Expertise.</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
        <br />
        <br />
        <br />
        <br />
      <h2 className="head-text">
          <span>Certifications</span>
      </h2>

      <div className="app__profiles">
        {certificates.map((certificate, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={certificate.name + index}
          >
            <a href={certificate.url} target='_blank' rel="noreferrer">
              <img src={urlFor(certificate.imgUrl)} style={{ height: '200px'}} alt={certificate.name} /> 
            </a>
            <h2 className="bold-text" style={{ marginTop: 20, textAlign: 'center' }}>{certificate.name}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{certificate.company}</p>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default AppWrapper(
  MotionWrapper(About, 'app__about'), 
  'about',
  'app__whitebg'
)